

import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Construction', href: '/construction' },
    { name: 'Landscape', href: '/landscape' },
    { name: 'Portfolio', href: '/portfolio' },
    { name: 'About Us', href: '/about' },
    { name: 'Contact', href: '/contact' }
  ];

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="flex items-center">
            <div className="w-12 h-12 bg-red-700 rounded-lg flex items-center justify-center mr-3">
              <i className="ri-hammer-line text-white text-xl"></i>
            </div>
            <div>
              <h1 className="text-2xl font-bold text-red-700" style={{ fontFamily: '"Pacifico", serif' }}>
                Chavez Castro
              </h1>
              <p className="text-sm text-gray-600">Construction & Landscape</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-gray-700 hover:text-red-700 font-medium transition-colors ${
                  location.pathname === item.href ? 'text-red-700 border-b-2 border-red-700' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Client Login Button */}
          <div className="hidden md:flex items-center space-x-4">
            <Link to="/login">
              <Button variant="outline" size="sm">
                <i className="ri-user-line mr-2"></i>
                Client Login
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-red-700"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <div className="flex flex-col space-y-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="text-gray-700 hover:text-red-700 font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Link to="/login" onClick={() => setIsMenuOpen(false)}>
                <Button variant="outline" size="sm" className="w-full">
                  <i className="ri-user-line mr-2"></i>
                  Client Login
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

